module.exports = __webpack_public_path__ + "media/images/facebook-aa58affde3bc04127fba51f0335f71fa.svg";